export const environment = {
  production: false,
  apiBaseUrl: 'https://api-testes.aquelecrm.online/api',
} as const;
